<div class="model-content bg-secondary">
    <div class="madel-header ">
        <h3 mat-dialog-title class="model-title">Asset Transfer Approval</h3>
    </div>
    <div>
        <button class="close" mat-button (click)="onClick()">X</button>
    </div>
</div>

<div class="p-2">
    <mat-vertical-stepper  #stepper>
        <mat-step label="Asset Transfer Request Form" >
            <div>
                <div>
                    <h4 class="fusion_details">Fusion Details</h4>
                </div>
                <div class="building_Flex">
                    <div class="building_grid">
                        <div>
                            <div class="form-group">
                                <label for="" class="build_label">Building Code</label>
                                <h6 class="building_from_text">36598745</h6>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label for="" class="build_label">Building Name</label>
                                <h6 class="building_from_text">Saraswathi Soudham, Ameerpet</h6>
                            </div>
                        </div>

                        <div>
                            <div class="form-group">
                                <label for="" class="build_label">Branch Code</label>
                                <h6 class="building_from_text">215479544</h6>
                            </div>
                        </div>

                        <div>
                            <div class="form-group">
                                <label for="" class="build_label">Branch Name</label>
                                <h6 class="building_from_text">Saraswathi Soudham, Ameerpet</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <h4 class="fusion_details">Authorised Person </h4>
                </div>

                <div class="building_Flex">
                    <div class="building_grid">
                        <div>
                            <div class="form-group">
                                <label for="" class="build_label">AGM Name</label>
                                <h6 class="building_from_text">Kancharlapalli Siva Rama Krishna</h6>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label for="" class="build_label">Dean Name</label>
                                <h6 class="building_from_text">Kancharlapalli Siva Rama Krishna</h6>
                            </div>
                        </div>

                        <div>
                            <div class="form-group">
                                <label for="" class="build_label">Principal Name</label>
                                <h6 class="building_from_text">Kancharlapalli Siva Rama Krishna</h6>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="Authorised">
                    <h4 class="fusion_details">Authorised Person </h4>
                    <h4 class="Authorised_person">Assets Images </h4>
                </div>

                <div class="building_Flex">
                    <div class="building_grid">
                        <div>
                            <div class="form-group">
                                <label for="" class="build_label">Assets Code</label>
                                <h6 class="building_from_text">60050003</h6>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label for="" class="build_label">Major Category</label>
                                <h6 class="building_from_text">Lease Hold Improvements</h6>
                            </div>
                        </div>

                        <div>
                            <div class="form-group">
                                <label for="" class="build_label">Minor Category</label>
                                <h6 class="building_from_text">Art & Paintings - Capex</h6>
                            </div>
                        </div>

                        <div>
                            <div class="form-group">
                                <label for="" class="build_label">Asset Type</label>
                                <h6 class="building_from_text">-</h6>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label for="" class="build_label">Asset Description</label>
                                <h6 class="building_from_text">-</h6>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label for="" class="build_label">Reason for Transfer</label>
                                <h6 class="building_from_text">-</h6>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label for="" class="build_label">Transport Cost</label>
                                <h6 class="building_from_text">2,500</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </mat-step>
        <mat-step label="Asset Transfer Approval" >
            <div>
                <div>
                    <h4 class="fusion_details">Transferor Branch FA SPOC Details</h4>
                </div>
                <ul class="asset_description">Approver Name
                    <li class="asset_text">
                        <textarea class="form-control" aria-label="With textarea"></textarea>
                    </li>
                </ul>
                <ul class="asset_description">Designation
                    <li class="asset_text">
                        <textarea class="form-control" aria-label="With textarea"></textarea>
                    </li>
                </ul>
                <ul class="asset_description">Emp ID
                    <li class="asset_text">
                        <textarea class="form-control" aria-label="With textarea"></textarea>
                    </li>
                </ul>
                <ul class="asset_description">
                    <li class="asset_text">Comments
                        <textarea class="form-control" aria-label="With textarea"></textarea>
                    </li>
                </ul>

                <div class="text-center d-flex justify-content-center gap-3 pt-3 pb-3">
                <button class="approval_btn" (click)="Approve()">Apporve</button>
                <button class="reject" (click)="reject()">Reject</button>
            </div>
            </div>
        </mat-step>

    </mat-vertical-stepper>
</div>